module.exports = __webpack_public_path__ + "static/media/selected_mooring_marker.a3a6c5ed.svg";